














































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

import CardsSectionBase from "@share/common/cards-section/CardsSectionBase.vue";
import CardsSectionGrid from "@share/common/cards-section/CardsSectionGrid.vue";
import CommitteeFilterDateSwitcher from '@share/date-switcher/CommitteeFilterDateSwitcher.vue';
import CommitteeCard from "@share/committees/committees-list/components/card/CommitteeCard.vue";
import CommitteeFilter from "@share/committees/committees-list/components/filter/CommitteeFilter.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Overlay from "@share/common/Overlay.vue";
import Paginatable from "@share/common/service-components/pagination/Paginatable.vue";

import { CommitteeModel } from "@api/models/committees/CommitteeModel";
import { UserProfile } from "@api/models/UserProfile";
import { CommitteesListService } from "@share/committees/committees-list/services/CommitteesListService";
import { EventType } from "@share/common/types/enums/EventType";
import ToggleButton from "@common/vue-toggle-btn/toggle-btn.vue";
import CommitteeCardPlaceholder from "@share/committees/committees-list/components/card/CommitteeCardPlaceholder.vue";

import { getDefaultToggleOptions } from "@common/vue-toggle-btn/helpers/optionsFabric";
import { SelectableTagInterface } from "@api/models/interfaces/SelectableTagInterface";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { FilteringParams } from "../../types/FilteringParams";

import { ModalFilterState } from "@share/committees/committees-list/types/filterTypes";
import { Debounce } from "vue-debounce-decorator";
import {isBottom as isBottomFn} from "@common/isBottom";
import { QueryBuilder } from "@share/committees/committees-list/services/QueryBuilder";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { getIsCommitteeAllowed } from "@share/common/helpers/ticketSystemHelpers";
import { mainActions } from "@service/store/main/actions";
import { Notice } from "@service/components/toast/type/Notice";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { noticeActions } from "@service/store/notice/actions";

@Component({ components: { BounceSpinner, Overlay, CommitteeCardPlaceholder, CommitteeFilter, CommitteeFilterDateSwitcher, CardsSectionGrid, CommitteeCard, ToggleButton } })

export default class CardsSectionCommittees extends Mixins(CardsSectionBase, Paginatable) {

    private readonly COMMITTEES_SCHEMA_ID = "Committees";

    @Prop() tags: SelectableTagInterface[] | null;
    @Prop() userProfiles: Record<string, UserProfile | undefined>;
    @Prop() currentUserCompanyId: string;

    listService: CommitteesListService;
    items: CommitteeModel[] = [];
    keyword = "";
    isOnlyMine = false;
    toggleOptions = getDefaultToggleOptions();
    selectedTagsIds: string[] = [];
    subjectTypes?: TicketType[];

    created() {

        this.listService = new CommitteesListService(
            new QueryBuilder(this.pagingState, this.currentUserId, this.currentUserCompanyId),
            this.$repositories.get(RepositoryFabric.OBJECT),
            this.COMMITTEES_SCHEMA_ID
        );

        this.updateList();
    }

    mounted() {
        const parentElement = this.getParentElement();

        parentElement?.addEventListener('scroll', this.userScrollHandler);
    }

    getParentElement() {
        return this.$parent?.$el
    }

    getUserProfile(item: CommitteeModel) {
        return this.userProfiles && item.userIds.map((userId) => this.userProfiles[userId]).filter(i => i) || [];
    }

    destroyed() {
        const parentElement = this.getParentElement();
        parentElement?.removeEventListener('scroll', this.userScrollHandler)
    }

    async updateList() {

        if (this.isTheFirstPage) {
            this.pagingState.skip = 0;
            this.items = [];

            if(!this.tags?.length) {
                this.$emit("loadTags");
            }
        }

        try {
            this.isLoading = true;
            this.pagingState.skip = this.items.length;

            const items = await this.listService.load(this.filterState);
            const userIds = new Set(items.map((item) => item.userIds).flat());

            this.$emit("updateUserProfiles", Array.from(userIds));

            this.items = this.isTheFirstPage ? items : this.items.concat(items);
        }
        catch(e) {
            this.$store.dispatch('reportException', e);
        }
        finally {
             this.isLoading = false;
        }
    }

    async deleteCommittee(commiteeId: string) {
        try {
            await this.listService.delete(commiteeId);
            this.items = this.items.filter((item) => item.id !== commiteeId);
        }
        catch(e) {
            this.$store.dispatch('reportException', e);

            const notice: Notice = {
                text: this.$t("committees.form.messages.failedDelete").toString(),
                level: NoticeLevel.danger
            }

            this.$store.dispatch(noticeActions.submitNotice, notice);
        }
    }

    @Debounce(250)
    userScrollHandler() {
        const isBottom = isBottomFn(this.getParentElement() as HTMLElement)
        if (isBottom) {
            if(this.turnOverPageIfNeed(this.items.length)) {
                this.updateList();
            }
        }
    }

    @Watch('filterState')
    watchSelectedDate() {
        this.updateList();
    }

    toggleIsOnlyMine(isOnlyMine: boolean) {
        this.isOnlyMine = isOnlyMine;
        this.updateList();
    }

    filterTagsOrSubject({ subjectType, tagsIds }: ModalFilterState) {
        this.subjectTypes = subjectType === "all" ? [TicketType.idea, TicketType.problem] : [subjectType]
        tagsIds && (this.selectedTagsIds = tagsIds);
    }

    @Debounce(700)
    filterKeyword(value: string) {
        this.keyword = value;
    }

    clearFilterState() {
        this.subjectTypes = [TicketType.idea, TicketType.problem];
        this.selectedTagsIds = [];
    }

    filterTz(offsetValue: string) {
        this.$store.dispatch(mainActions.setSelectedTimeZone, offsetValue);
    }

    get count() {
        return this.pagingState.count;
    }

    get timeDirection() {
        return this.$vnode.key === EventType.upcoming ? '$gte' : '$lte'
    }

    get cardType() {
        return this.$vnode.key
    }

    get filterState(): FilteringParams {
        return {
            date: this.selectedDate,
            timeZone: this.selectedTimeZone,
            tagsIds: this.selectedTagsIds,
            subjectTypes: this.subjectTypes,
            keyword: this.keyword,
            timeDirection: this.timeDirection,
            isOnlyMine: this.isOnlyMine
        }
    }

    get filterHasValue() {
        return this.selectedDate || this.subjectTypes?.length || this.selectedTagsIds.length || this.keyword
    }

    get sizeClass() {
        return this.getSizeClass(this.items);
    }

    get currentUserId() {
        return this.$store.state.session.userId as number;
    }

    get isAdmin() {
        return this.$store.getters['isAdmin'];
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    get showAddCommittee() {
        return this.items.length < 8 && this.cardType === "upcoming" && this.isCommitteeAdmin && this.isOnEditing;
    }

    get isCommitteeAdmin() {
        return getIsCommitteeAllowed(this.$store.getters["groupIds"]) && this.isAdmin && this.isOnEditing;
    }

    get title() {
        return this.cardType === "upcoming" ? this.$t('common.upcoming') : this.$t('common.past')
    }
}

